import { bindActionCreators } from 'redux';

import { PriceType } from '../../types/price';
import { ProductType } from '../../types/product';
import CartActions from '../../actions/cart';
import CustomerActions from '../../actions/customer';
import ModalActions from '../../actions/modal';
import PriceActions from '../../actions/price';
import ProductActions from '../../actions/product';

export default {
  defaultProps: {
    needsType: null,
  },
  // @ts-expect-error - Automatic, Please fix when editing this file
  mapDispatchToProps: (dispatch) => ({
    actions: {
      cart: bindActionCreators(CartActions, dispatch),
      customer: bindActionCreators(CustomerActions, dispatch),
      modal: bindActionCreators(ModalActions, dispatch),
      price: bindActionCreators(PriceActions, dispatch),
      product: bindActionCreators(ProductActions, dispatch),
    },
  }),
};

export type ProductListingProps = {
  actions: Object;
  customer: Object;
  needsType: string;
  prices: Record<string, PriceType>;
  products: ProductType[];
  useFutureEffectiveDate: boolean;
};
